import { useRef, useState, useEffect } from 'react';
import useMediaQuery from '../../custom-hooks/useMediaQuery';
import { device } from '../../../utils/styled-component-mixins';
import MobileSortMenuStyled from './MobileSortMenuStyled';

const MobileSortMenu = ({
  showMobileSortMenu,
  setShowMobileSortMenu,
  sortFilters,
  sortBy,
  sortFiltersLabel
}) => {
  const isDesktop = useMediaQuery(device.desktop);
  const sortFilterContainerRef = useRef(null);
  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 992) {
      // handle filter menu toggle animation
      const body = document.querySelector('body');

      if (!showMobileSortMenu || isFirstRender) {
        const timeOut = isFirstRender ? 0 : 350;

        setTimeout(() => {
          sortFilterContainerRef.current.classList.add('hidden');
        }, timeOut);
        sortFilterContainerRef.current.classList.remove('transition-in');
        sortFilterContainerRef.current.classList.add('transition-out');

        body.style.overflow = 'auto';
        body.style.position = 'relative';
        setIsFirstRender(false);
      } else if (showMobileSortMenu) {
        sortFilterContainerRef.current.classList.remove('hidden');
        sortFilterContainerRef.current.classList.remove('transition-out');
        sortFilterContainerRef.current.classList.add('transition-in');
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
      }
    }
  }, [showMobileSortMenu, isDesktop]);

  return (
    <MobileSortMenuStyled>
      <div ref={sortFilterContainerRef} id="search-sortby" className="filters-container hidden">
        <fieldset aria-live="polite">
          <legend className="filter-legend">
            <span className="material-icons">sort</span>
            {sortFiltersLabel}
          </legend>
          <button
            className="mobile-filter-close"
            aria-label="close filters"
            aria-haspopup="true"
            aria-expanded="true"
            onClick={() => setShowMobileSortMenu(!showMobileSortMenu)}
          >
            <span className="material-icons-round">close</span>
          </button>
          {sortFilters[0].filterOptions.map((filter, index) => (
            <div className="filter-group" key={filter}>
              <input
                checked={parseInt(sortBy, 10) === index}
                onChange={() => sortFilters[0].onChange(filter)}
                type="checkbox"
                id={filter}
                name="filter"
                value={filter}
              />
              <label htmlFor={filter}>{filter}</label>
            </div>
          ))}
        </fieldset>
      </div>
    </MobileSortMenuStyled>
  );
};

export default MobileSortMenu;
